<div class="address-form">
  @if (showTitle()) {
    <h4>{{ 'shared.address.header' | translate }}</h4>
  }

  <form nz-form nzLayout="vertical" [formGroup]="formGroup()">
    <moxi-place-autocomplete
      [formGroup]="formGroup()"
      [searchTerm]="searchTerm()"
      [required]="required()"
      [placeholder]="'global.searchAddress' | translate"
      (placeChanged)="onAutocompleteUpdate($event)"
    />

    <div class="address-form__additional-info">
      <span
        nz-checkbox
        [nzChecked]="additionalInfo()"
        (nzCheckedChange)="additionalInfo.set($event)"
      >
        {{ 'shared.address.additionalInfoLabel' | translate }}
      </span>

      <div nz-row [nzGutter]="32">
        @if (additionalInfo()) {
          <div nz-col [nzSpan]="24" [nzLg]="12">
            <nz-form-item>
              <nz-form-label nzFor="addition">
                {{ 'shared.address.additionalAddressLabel' | translate }}
              </nz-form-label>
              <nz-form-control>
                <input
                  id="addition"
                  nz-input
                  formControlName="addition"
                  [placeholder]="
                    'shared.address.additionalAddressPlaceholder' | translate
                  "
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzSpan]="24" [nzLg]="12">
            <nz-form-item>
              <nz-form-label nzFor="instructions">
                {{ 'shared.address.driverInstructionsLabel' | translate }}
              </nz-form-label>
              <nz-form-control>
                <input
                  id="instructions"
                  nz-input
                  formControlName="instructions"
                  [placeholder]="
                    'shared.address.driverInstructionsPlaceholder' | translate
                  "
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        }
      </div>
    </div>
  </form>
</div>
